import React, { useState } from 'react';
import TagsModal from 'components/activity/TagsModal';
import RecordableTypes from 'constants/recordableTypes';

const NO_ACTION = null;
const NO_MODAL = () => {};
const EMPTY_RESULT = [NO_ACTION, NO_MODAL];

export default function useMenuActionTag({
  assets,
  taggingSectionPhotos,
  handleTagSave,
}) {
  const [modalVisible, setModalVisible] = useState(false);

  const hasPermission = true;
  const validSelection = assets.length > 0;

  if (!hasPermission || (!validSelection && !taggingSectionPhotos)) {
    return EMPTY_RESULT;
  }

  const action = () => {
    setModalVisible(true);
  };
  const nodeIds = assets.map((asset) => asset.id);

  const renderModal = () =>
    !modalVisible ? null : (
      <TagsModal
        action="ADD"
        handleTagSave={handleTagSave}
        taggingSectionPhotos={taggingSectionPhotos}
        nodeIds={nodeIds}
        recordableType={RecordableTypes.PHOTO}
        onRequestClose={() => {
          setModalVisible(false);
        }}
      />
    );

  return [action, renderModal];
}
